<template>
  <sequential-entrance delay="1000" fromTop tag="section">
    <div class="py-12 bg-white">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div>
          <dl
            class="divide-y divide-gray-100 divide-x space-y-10 md:space-y-0 md:grid md:grid-cols-3 md:gap-x-8 md:gap-y-10"
          >
            <div
              @click="viewRental"
              class="cursor-pointer hover:bg-gray-100 relative p-2 rounded-md"
            >
              <dt>
                <div
                  class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white"
                >
                  <!-- Heroicon name: outline/scale -->
                  <svg
                    class="h-6 w-6 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                    />
                  </svg>
                </div>
                <p class="ml-16 text-lg leading-6 font-medium text-gray-900">
                  View Rentals
                </p>
              </dt>
              <dd class="mt-2 ml-16 text-base text-gray-500">
                Need property management?
              </dd>
            </div>

            <div
              @click="viewListing"
              class="cursor-pointer hover:bg-gray-100 relative p-2 rounded-md"
            >
              <dt>
                <div
                  class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white"
                >
                  <!-- Heroicon name: outline/lightning-bolt -->
                  <svg
                    class="h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M13 10V3L4 14h7v7l9-11h-7z"
                    />
                  </svg>
                </div>
                <p class="ml-16 text-lg leading-6 font-medium text-gray-900">
                  View Listings
                </p>
              </dt>
              <dd class="mt-2 ml-16 text-base text-gray-500">
                Find your home
              </dd>
            </div>

            <div
              @click="contact"
              class="cursor-pointer hover:bg-gray-100 relative p-2 rounded-md"
            >
              <dt>
                <div
                  class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white"
                >
                  <!-- Heroicon name: outline/annotation -->
                  <svg
                    class="h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
                    />
                  </svg>
                </div>
                <p class="ml-16 text-lg leading-6 font-medium text-gray-900">
                  Contact 360 Real Estate
                </p>
              </dt>
              <dd class="mt-2 ml-16 text-base text-gray-500">
                Notified when more listings become available.
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  </sequential-entrance>
</template>

<script>
export default {
  data() {
    return {};
  },

  methods: {
    viewListing() {
      this.$router.push({ name: "listings" });
    },
    viewRental() {
      this.$router.push({ name: "rentals" });
    },

    contact() {
      this.$router.push({ name: "Contact" });
    }
  }
};
</script>
